<template>
    <span class="pt-breadcrumb__item">
        <span ref="link" :class="['pt-breadcrumb__inner', to ? 'is-link' : '']" role="link">
            <slot></slot>
        </span>
        <pt-icon
            v-if="separatorIcon"
            :icon="separatorIcon"
            :style="separatorIconStyle"
            class="pt-breadcrumb__separator"
        ></pt-icon>
        <span v-else class="pt-breadcrumb__separator" role="presentation">{{ separator }}</span>
    </span>
</template>

<script lang="ts">
import { defineComponent, inject, ref, onMounted, getCurrentInstance } from 'vue';
import type { IBreadcrumbProps } from './breadcrumb';
import type { PropType } from 'vue';

export default defineComponent({
    name: 'PtBreadcrumbItem',
    props: {
        to: {
            type: [String, Object] as PropType<string | Record<string, unknown>>,
            default: '',
        },
        replace: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const link = ref(null);
        const parent = inject<IBreadcrumbProps>('breadcrumb');
        const instance = getCurrentInstance();
        const router = instance.appContext.config.globalProperties.$router;

        onMounted(() => {
            link.value.setAttribute('role', 'link');
            link.value.addEventListener('click', () => {
                if (!props.to || !router) return;
                props.replace ? router.replace(props.to) : router.push(props.to);
            });
        });

        return {
            link,
            separator: parent?.separator,
            separatorIcon: parent?.separatorIcon,
            separatorIconStyle: parent?.separatorIconStyle,
        };
    },
});
</script>
